import Vue from "vue"
import Vuex from "vuex"

import sessao from "./sessao"
import filtro from "./filtro"
import informacoes from "./informacoes"
import leitos from "./leitos"
import consultas from "./consultas"
import internacao from "./internacao"
import altahospitalar from "./altahospitalar"
import impedimento from "./impedimento"
import liberar from "./liberar"
import transferir from "./transferir"
import ceder from "./ceder"
import reservar from "./reservar"
import aih from "./aih"
import tipoleito from "./tipoleito"
import longapermanencia from "./longapermanencia"
import relatorios from "./relatorios"
import covid from "./covid"

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        sessao,
        filtro,
        informacoes,
        leitos,
        consultas,
        internacao,
        altahospitalar,
        impedimento,
        liberar,
        transferir,
        ceder,
        reservar,
        aih,
        tipoleito,
        longapermanencia,
        relatorios,
        covid
    }
});

export default store;
